/* Pack Builder v5 - Sin limite, con nombre en resumen */
(function(){
"use strict";

var CM={"negro":"#1a1a1a","beige":"#d4b896","chocolate":"#5c3a1e","café":"#6b4226","café claro":"#a67c52","blanco":"#fff","gris":"#888","azul":"#1565c0","cherry":"#8b0000","rosa":"#e8a0bf","piel":"#deb887","verde":"#2e7d32","gris oscuro":"#555"};

var PB={
  "pack-arma-t-body":{
    t:"ARMA TU PACK",
    s:"Elige tus productos",
    products:["body-figura-ideal","body-silueta-perfecta","body-curvy-ml","body-full-figura","body-figura-ideal-negro","body-fit-mc","body-diosa-fit-copia","body-fajero-princesa"]
  }
};

var D={};
var cfg=null;
var pState={};
var cart=[];

function gImg(p,color){
  var fallback=p.featured_image||(p.images&&p.images[0])||"";
  if(!color)return fallback;
  for(var i=0;i<p.variants.length;i++){
    var v=p.variants[i];
    if((v.option1||"").toLowerCase()===color.toLowerCase()&&v.featured_image&&v.featured_image.src)return v.featured_image.src;
  }
  return fallback;
}

function findVariant(handle,color,size){
  var p=D[handle];if(!p)return null;
  for(var i=0;i<p.variants.length;i++){
    var v=p.variants[i];
    var opts=[v.option1||"",v.option2||"",v.option3||""];
    var hasColor=opts.some(function(o){return o.toLowerCase()===color.toLowerCase();});
    var hasSize=opts.some(function(o){return o===size;});
    if(hasColor&&hasSize&&v.available!==false)return v;
  }
  return null;
}

function colorHasStock(p,color){
  for(var i=0;i<p.variants.length;i++){
    var v=p.variants[i];
    var opts=[v.option1||"",v.option2||"",v.option3||""];
    if(opts.some(function(o){return o.toLowerCase()===color.toLowerCase();})&&v.available!==false)return true;
  }
  return false;
}

function sizeAvailable(p,color,size){
  for(var i=0;i<p.variants.length;i++){
    var v=p.variants[i];
    var opts=[v.option1||"",v.option2||"",v.option3||""];
    var hasC=!color||opts.some(function(o){return o.toLowerCase()===color.toLowerCase();});
    var hasS=opts.some(function(o){return o===size;});
    if(hasC&&hasS&&v.available!==false)return true;
  }
  return false;
}

function totalQty(){
  var t=0;cart.forEach(function(c){t+=c.qty;});return t;
}

function findCartItem(handle,color,size){
  for(var i=0;i<cart.length;i++){
    if(cart[i].handle===handle&&cart[i].color.toLowerCase()===color.toLowerCase()&&cart[i].size===size)return i;
  }
  return -1;
}

function addToCart(idx){
  var handle=cfg.products[idx];
  var st=pState[idx];
  if(!st.cl||!st.sz)return;
  var v=findVariant(handle,st.cl,st.sz);
  if(!v)return;
  var p=D[handle];
  var ci=findCartItem(handle,st.cl,st.sz);
  if(ci>-1){cart[ci].qty++;}
  else{cart.push({handle:handle,name:p.title,color:st.cl,size:st.sz,vid:v.id,qty:1});}
  render();
}

function removeFromCart(ci){
  if(ci<0||ci>=cart.length)return;
  cart[ci].qty--;
  if(cart[ci].qty<=0)cart.splice(ci,1);
  render();
}

function render(){
  var c=document.getElementById("scpb-products");if(!c)return;
  var total=totalQty();
  var parts=[];

  cfg.products.forEach(function(handle,idx){
    var p=D[handle];if(!p)return;
    var st=pState[idx];
    var cOpt=null;var tOpt=null;
    p.options.forEach(function(o){var n=o.name.toLowerCase();
      if(n.indexOf("color")>-1)cOpt=o;
      if(n.indexOf("talla")>-1||n==="size")tOpt=o;});

    var img=gImg(p,st.cl);
    var price=p.variants[0].price;
    var canAdd=st.cl&&st.sz&&!!findVariant(handle,st.cl,st.sz);

    parts.push('<div class="scpb__row">');
    parts.push('<img class="scpb__row-img" src="'+img+'" alt="'+p.title+'">');
    parts.push('<div class="scpb__row-body">');

    parts.push('<div class="scpb__row-head">');
    parts.push('<span class="scpb__row-name">'+p.title+'</span>');
    parts.push('<span class="scpb__row-price">$'+Math.round(price).toLocaleString("es-CL")+'</span>');
    parts.push('</div>');

    parts.push('<div class="scpb__row-controls">');
    parts.push('<div class="scpb__row-opts">');

    if(cOpt&&cOpt.values.length>0){
      parts.push('<div class="scpb__colors">');
      cOpt.values.forEach(function(cv,ci){
        var bg=CM[cv.toLowerCase()]||"#ccc";
        var on=st.cl&&st.cl.toLowerCase()===cv.toLowerCase()?" active":"";
        var out=colorHasStock(p,cv)?"":" out";
        var border=cv.toLowerCase()==="blanco"?"border:2px solid #ddd":"";
        var ttl=out?cv+" - Sin stock":cv;
        parts.push('<div class="scpb__clr'+on+out+'" style="background:'+bg+';'+border+'" data-i="'+idx+'" data-c="'+ci+'" title="'+ttl+'"></div>');
      });
      parts.push('</div>');
    }

    if(tOpt){
      parts.push('<div class="scpb__sizes">');
      tOpt.values.forEach(function(tv,ti){
        var on=st.sz===tv?" active":"";
        var out=sizeAvailable(p,st.cl,tv)?"":" out";
        parts.push('<button type="button" class="scpb__sz'+on+out+'" data-i="'+idx+'" data-t="'+ti+'" title="'+(out?tv+" - Sin stock":tv)+'">'+tv+'</button>');
      });
      parts.push('</div>');
    }

    parts.push('</div>');
    parts.push('<button type="button" class="scpb__add'+(canAdd?'':' off')+'" data-i="'+idx+'">+</button>');
    parts.push('</div>');
    parts.push('</div>');
    parts.push('</div>');
  });

  /* Batch all DOM writes together to trigger a single layout/paint */
  var summaryEl=document.getElementById("scpb-summary");
  var countEl=document.getElementById("scpb-count");
  var btnEl=document.getElementById("scpb-cart");

  /* Build summary HTML */
  var shtml;
  var showSummary;
  if(cart.length>0){
    var sParts=[];
    cart.forEach(function(item,ci){
      sParts.push('<div class="scpb__cart-item">');
      sParts.push('<span>'+item.qty+'x '+item.name+' — '+item.color+' — '+item.size+'</span>');
      sParts.push('<button type="button" class="scpb__cart-rm" data-ci="'+ci+'" title="Quitar">×</button>');
      sParts.push('</div>');
    });
    shtml=sParts.join('');
    showSummary=true;
  }else{
    shtml='';
    showSummary=false;
  }

  /* Single batched DOM write */
  c.innerHTML=parts.join('');
  summaryEl.innerHTML=shtml;
  summaryEl.style.display=showSummary?'block':'none';
  countEl.textContent=total;

  if(total>0){
    btnEl.disabled=false;
    btnEl.textContent="AGREGAR PACK AL CARRITO";
    btnEl.className="scpb__cart ready";
  }else{
    btnEl.disabled=true;
    btnEl.textContent="Agrega productos a tu pack";
    btnEl.className="scpb__cart";
  }
}

function bindEvents(){
  var prodEl=document.getElementById("scpb-products");
  var summaryEl=document.getElementById("scpb-summary");
  var cartBtn=document.getElementById("scpb-cart");

  prodEl.addEventListener("click",function(e){
    var clr=e.target.closest(".scpb__clr");
    if(clr){
      if(clr.classList.contains("out"))return;
      var idx=parseInt(clr.getAttribute("data-i"));
      var ci=parseInt(clr.getAttribute("data-c"));
      var p=D[cfg.products[idx]];
      var cOpt=null;
      p.options.forEach(function(o){if(o.name.toLowerCase().indexOf("color")>-1)cOpt=o;});
      if(cOpt) pState[idx].cl=cOpt.values[ci];
      /* If currently selected size is unavailable for new color, deselect it */
      if(pState[idx].sz&&!sizeAvailable(p,pState[idx].cl,pState[idx].sz))pState[idx].sz=null;
      render();return;
    }

    var szBtn=e.target.closest(".scpb__sz");
    if(szBtn){
      if(szBtn.classList.contains("out"))return;
      var idx2=parseInt(szBtn.getAttribute("data-i"));
      var ti=parseInt(szBtn.getAttribute("data-t"));
      var p2=D[cfg.products[idx2]];
      var tOpt=null;
      p2.options.forEach(function(o){var n=o.name.toLowerCase();if(n.indexOf("talla")>-1||n==="size")tOpt=o;});
      if(tOpt) pState[idx2].sz=tOpt.values[ti];
      render();return;
    }

    var addBtn=e.target.closest(".scpb__add");
    if(addBtn&&!addBtn.classList.contains("off")){
      var idx3=parseInt(addBtn.getAttribute("data-i"));
      addToCart(idx3);
      return;
    }
  });

  summaryEl.addEventListener("click",function(e){
    var rm=e.target.closest(".scpb__cart-rm");
    if(rm){
      var ci=parseInt(rm.getAttribute("data-ci"));
      removeFromCart(ci);
    }
  });

  cartBtn.addEventListener("click",function(){
    if(totalQty()<1)return;
    var items=cart.map(function(c){return{id:c.vid,quantity:c.qty}});
    if(!items.length)return;
    cartBtn.textContent="AGREGANDO...";cartBtn.disabled=true;
    fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},credentials:"same-origin",body:JSON.stringify({items:items})})
    .then(function(r){return r.json().then(function(j){return{ok:r.ok&&!j.status,data:j}})})
    .then(function(res){
      if(!res.ok){
        var msg=(res.data&&(res.data.description||res.data.message))||"No se pudo agregar al carrito";
        cartBtn.textContent=msg.length>40?"ERROR — revisa stock":msg;
        cartBtn.disabled=false;
        console.error("[pack-builder] add failed:",res.data);
        return;
      }
      cartBtn.textContent="PACK AGREGADO!";cartBtn.className="scpb__cart added";
      document.dispatchEvent(new CustomEvent("cart:added",{detail:res.data}));
      setTimeout(function(){window.location.href="/cart"},800);
    })
    .catch(function(err){cartBtn.textContent="ERROR DE CONEXIÓN";cartBtn.disabled=false;console.error("[pack-builder] network:",err);});
  });
}

function loadProducts(){
  var fetches=cfg.products.map(function(h){
    return fetch("/products/"+h+".js")
      .then(function(r){return r.json()})
      .then(function(data){D[h]=data;})
      .catch(function(){/* product fetch failed, skip */});
  });
  Promise.all(fetches).then(function(){render();bindEvents();});
}

function setup(){
  var el=document.getElementById("scpb");if(!el)return;
  var handle=el.getAttribute("data-pack-handle");

  var cfgEl=document.getElementById("scpb-config");
  if(cfgEl){try{cfg=JSON.parse(cfgEl.textContent);}catch(e){}}

  if(!cfg||!cfg.products||!cfg.products.length){
    if(handle&&PB[handle]) cfg=PB[handle];
  }

  if(!cfg||!cfg.products||!cfg.products.length){
    el.style.display="none";return;
  }

  el.querySelector(".scpb__title").textContent=cfg.t;
  el.querySelector(".scpb__sub").textContent=cfg.s;

  cfg.products.forEach(function(_,idx){pState[idx]={cl:null,sz:null}});
  loadProducts();
}

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",setup);
}else{
  if(typeof requestIdleCallback==="function"){
    requestIdleCallback(setup);
  }else{
    setup();
  }
}
})();
